import React, { ReactElement } from 'react';
import classNames from 'classnames';
import ReactModal from 'react-modal';
import { Icon } from '@ver-uds/uswds-react';
import Button from '../Button';
import ModalContent, { ModalContentProps } from './ModalContent';
import ModalFooter, { ModalFooterProps } from './ModalFooter';

type Level = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
export interface ModalProps {
  fixedToTop?: boolean;
  id: string;
  header: string | JSX.Element;
  headerAs?: Level;
  children: [ReactElement<ModalContentProps>, ReactElement<ModalFooterProps>] | ReactElement<ModalContentProps>;
  open: boolean;
  close(): void;
  hasDismissButton?: boolean;
  shouldReturnFocusAfterClose?: boolean;
}

const Modal = ({
  fixedToTop,
  id,
  header,
  headerAs: HeaderAs = 'h2',
  children,
  open,
  close,
  hasDismissButton = true,
  shouldReturnFocusAfterClose = true,
}: ModalProps): JSX.Element => {
  const headerId = `${id}-header`;

  return (
    <ReactModal
      isOpen={open}
      aria={{ labelledby: headerId }}
      bodyOpenClassName="ver-modal__body--open"
      htmlOpenClassName="ver-modal__html--open"
      className={classNames('ver-modal', 'bg-dhs-seal', 'bg-dhs-seal--modal', {
        'ver-modal--fixed-to-top': fixedToTop,
      })}
      overlayClassName="ver-modal__overlay"
      onRequestClose={close}
      shouldReturnFocusAfterClose={shouldReturnFocusAfterClose}
    >
      <header className="ver-modal__header">
        {hasDismissButton && (
          <Button type="button" variant="tertiary" className="ver-modal__close" onClick={close} aria-label="close">
            <Icon name="close" size={3} />
          </Button>
        )}
        <HeaderAs id={headerId} className="ver-modal__title">
          {header}
        </HeaderAs>
      </header>
      {children}
    </ReactModal>
  );
};

Modal.Content = ModalContent;
Modal.Footer = ModalFooter;

Modal.setAppElement = ReactModal.setAppElement.bind(null);

export default Modal;
